import { Stack } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { shallowEqual } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import useAsyncGetUnrespondedMessages from '../../../../hooks/useAsyncGetUnrespondedMessages';
import { InboxItemsResponse } from '../../../../sic-lib/api/newRecent/types/InboxItemsResponse';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import PageStatus from '../../../Navigation/PageStatus/PageStatus';
import UnreadMessagesListItem from '../UnreadMessagesListItem/UnreadMessagesListItem';

const useStyles = makeStyles()((theme: Theme) => ({
    flexWrapper: {
        height: '100%',
        overflow: 'auto',
    },
    flexItem: {
        margin: theme.spacing(0, 0),
    },
}));

export default function UnrespondedMessageList() {
    const dispatch = useAppDispatch();
    const { classes } = useStyles();

    const store = useAppSelector(state => {
        return {
            clientId: state.user?.clientId || -1,
            userName: state.user?.userName || '',
        };
    }, shallowEqual);

    /*React.useEffect(() => {
        dispatch(conversationActions.requestContactConversation());
    }, [store.contactId, store.page, store.channels]);
    */

    const [unrespondedMessages, setUnrespondedMessages] = React.useState<InboxItemsResponse>();

    const { requestStatus, asyncGetUnrespondedMessages } = useAsyncGetUnrespondedMessages();

    React.useEffect(() => {
        async function request() {
            const asyncResult = await asyncGetUnrespondedMessages(store.clientId, store.userName);

            if (asyncResult) {
                setUnrespondedMessages(asyncResult);
            }
        }
        request();
    }, []);

    return (
        <PageStatus
            showError={requestStatus === RequestStatus.error}
            showLoading={requestStatus !== RequestStatus.success}
        >
            <Stack direction="column">
                {unrespondedMessages &&
                    unrespondedMessages.items &&
                    unrespondedMessages.items.map(itm => (
                        <UnreadMessagesListItem config={itm} key={itm.contactId} />
                    ))}
            </Stack>
        </PageStatus>
    );
}
